import type { I18n as VueI18n, Locale } from 'vue-i18n';
import { createI18n as createVueI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '@/common/utils/constants';
import zhCN from '@/common/locales/zh-CN.yaml';
import enUS from '@/common/locales/en-US.yaml';

export type I18n = VueI18n<NonNullable<unknown>, NonNullable<unknown>, NonNullable<unknown>, Locale, false>;

export function createI18n(language = DEFAULT_LANGUAGE) {
  return createVueI18n({
    legacy: false,
    allowComposition: true,
    locale: language,
    fallbackLocale: {
      'en-US': [DEFAULT_LANGUAGE],
    },
    messages: {
      'zh-CN': zhCN,
      'en-US': enUS,
    },
  }) as I18n;
}
